import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button.tsx"

export default function NotFound() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-4 text-center">
      <p className="font-mono text-6xl font-bold text-primary">404</p>
      <h1 className="text-xl font-semibold">Η σελίδα δεν βρέθηκε</h1>
      <p className="text-sm text-muted-foreground">Η διεύθυνση που ζητήσατε δεν υπάρχει.</p>
      <Button asChild>
        <Link to="/">Επιστροφή στην Αρχική</Link>
      </Button>
    </main>
  )
}
